import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

import { PopUpWindow as BasePopUpWindow } from '../../components/pop-up-window';
import { CARD_WIDTH } from '../../constants';

const PopUpWindow = styled(BasePopUpWindow)`
  && > * {
    max-width: ${CARD_WIDTH}px;
    max-height: 90vh;
  }

  @media ${mediaSmallOrTiny} {
    && > * {
      max-width: 100%;
      max-height: 100%;
    }
  }
`;

const ScrollableContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
`;

export default {
  PopUpWindow,
  ScrollableContent,
};
